import { BlockPage } from './block-page/BlockPage';

function App() {
  return <BlockPage/>;
}
export default App;
